module.exports = __webpack_public_path__ + "img/cameralens.4890ab41.png";